import { toJS } from 'mobx'
import { observer } from 'mobx-react-lite'
import React, { FC, useContext, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import styled from 'styled-components'

import { DetailList, InviteList, MainTitle, OrganisationExpander, SubTitle, ViewLoading } from '../components'
import { EditRemove } from '../components/general/OrgExpander/EditDeleteComponent'
import { StoreContext } from '../store'
import { ContentSection } from '../style/layout'
import { arrayIsEmpty } from '../utils/helpers'

const UserDetailViewComponent: FC = () => {
  const { t } = useTranslation()
  const { userDetailsStore, layoutStore } = useContext(StoreContext)
  const { id } = useParams()

  const { isLoading } = userDetailsStore

  useEffect(() => {
    userDetailsStore.fetchUserData(id)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (isLoading) {
    return <ViewLoading />
  }

  const { firstName, lastName, email, phone, userOrganizations, invites } = userDetailsStore

  return (
    <ContentSection gap="lg">
      <ContentSection gap="xl">
        <MainTitle>{t('editUser.title')}</MainTitle>
        <DetailList
          items={[
            { id: 'first-name', label: t('general.firstName'), value: firstName },
            { id: 'last-name', label: t('general.lastName'), value: lastName },
            { id: 'email', label: t('invite.userUsername'), value: email },
            { id: 'phone', label: t('general.phone'), value: phone },
          ]}
        />
      </ContentSection>
      <ContentSection>
        {toJS(userOrganizations).length > 0 && <SubTitle>{t('general.organisations')}</SubTitle>}

        {userOrganizations.map((org) => {
          return (
            <StyledOrgExpanderWrapper key={org.organization.businessId}>
              <OrganisationExpander
                organization={org.organization}
                selectedRoleValues={org.organizationUser.selectedRoles}
                selectedCustomerNumbers={org.organizationUser.selectedCustomerNumbers}
                selectedLCNumbers={org.organizationUser.selectedLogisticsContractNumbers}
                selectedTransportIds={org.organizationUser.selectedTransportIds}
                selectedBusinessPartnerNumbers={org.organizationUser.selectedBusinessPartnerNumbers}
                selectedPrincipalIds={org.organizationUser.selectedPrincipalIds}
                editable
                accountId={org.organizationUser.accountId}
                userEmail={org.organizationUser.email}
                isOpened={userOrganizations.length === 1}
              />

              {!layoutStore.isMobile && (
                <EditRemove
                  businessId={org.organization.businessId}
                  accountId={org.organizationUser.accountId}
                  email={org.organizationUser.email}
                />
              )}
            </StyledOrgExpanderWrapper>
          )
        })}
        {!arrayIsEmpty(invites) && <InviteList invites={invites} />}
      </ContentSection>
    </ContentSection>
  )
}

export const UserDetailView = observer(UserDetailViewComponent)

const StyledOrgExpanderWrapper = styled('div')`
  display: flex;
  flex-direction: row;
  align-items: start;
  gap: 16px;
`
